/* eslint-disable no-shadow */

export enum LocationTypes {
	point = 'Point',
	userAddressPoint = 'UserAddressPoint',
	anahuacPoint = 'AnahuacPoint',
	cedisPoint = 'CedisPoint',
	noLocation = 'NoLocation',
}

export enum GPSCommands {
	CUT_POWER = 'cut power',
	RESUME_POWER = 'resume power',
	GET_LOCATION = 'get location',
	SET_INTERVAL = 'set interval',
	SET_GEO_FENCE = 'set geofence',
	SET_ARM = 'set arm',
	SET_DISARM = 'set disarm',
}
